import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TurnRightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"turn_right"}/>
}
